import {createTheme} from "@aws-amplify/ui-react";
import {studioTheme} from "./ui-components";

// Taten mit Daten corporate design (../design/README.md) for the Amplify UI components.
// Values point at the CSS variables in index.css, so colours are defined in one place.
// Rules that shape the overrides below:
// - one coral, no tints: the brand scale has no light coral steps, only neutrals, coral and ink
// - text on light backgrounds is ink, never coral; text on coral is ink, never white
// - focus rings are ink
const ink = "var(--color-ink)";
const inkMuted = "var(--color-ink-muted)";
const accent = "var(--color-accent)";
const accentHover = "var(--color-accent-hover)";
const onAccent = "var(--color-on-accent)";
const bgWarm = "var(--color-bg-warm)";
const surface = "var(--color-surface)";
const rule = "var(--color-rule)";

export const appTheme = createTheme({
    name: "appTheme",
    tokens: {
        fonts: {
            default: {
                variable: {value: "'Inter', system-ui, -apple-system, sans-serif"},
                static: {value: "'Inter', system-ui, -apple-system, sans-serif"},
            },
        },
        colors: {
            brand: {
                primary: {
                    10: {value: bgWarm},
                    20: {value: rule},
                    40: {value: rule},
                    60: {value: inkMuted},
                    80: {value: accent},
                    90: {value: accentHover},
                    100: {value: ink},
                },
            },
            font: {
                primary: {value: ink},
                secondary: {value: inkMuted},
                tertiary: {value: inkMuted},
                interactive: {value: ink},
                hover: {value: ink},
                focus: {value: ink},
                active: {value: ink},
            },
            background: {
                primary: {value: surface},
                secondary: {value: bgWarm},
                tertiary: {value: rule},
            },
            border: {
                primary: {value: inkMuted},
                secondary: {value: rule},
                tertiary: {value: rule},
                focus: {value: ink},
            },
        },
        components: {
            // Buttons follow the website's .btn: radius md, weight 600
            button: {
                borderRadius: {value: "{radii.medium.value}"},
                fontWeight: {value: "{fontWeights.semibold.value}"},
                // Default (secondary) button: ink outline
                borderColor: {value: ink},
                color: {value: ink},
                _hover: {backgroundColor: {value: bgWarm}, borderColor: {value: ink}, color: {value: ink}},
                _focus: {backgroundColor: {value: bgWarm}, borderColor: {value: ink}, color: {value: ink}},
                _active: {backgroundColor: {value: rule}, borderColor: {value: ink}, color: {value: ink}},
                // Primary button: coral fill, ink text (the one highlight per view)
                primary: {
                    backgroundColor: {value: accent},
                    color: {value: onAccent},
                    _hover: {backgroundColor: {value: accentHover}, color: {value: onAccent}},
                    _focus: {backgroundColor: {value: accentHover}, color: {value: onAccent}},
                    _active: {backgroundColor: {value: accentHover}, color: {value: onAccent}},
                },
                // Menu items: like the website's nav links (ink on warm paper)
                menu: {
                    _hover: {backgroundColor: {value: bgWarm}, color: {value: ink}},
                    _focus: {backgroundColor: {value: bgWarm}, color: {value: ink}},
                    _active: {backgroundColor: {value: rule}, color: {value: ink}},
                },
            },
            // Cards follow the website's .card: white, rule border, radius lg
            card: {
                backgroundColor: {value: surface},
                borderRadius: {value: "{radii.large.value}"},
                padding: {value: "{space.large.value}"},
                outlined: {
                    borderRadius: {value: "{radii.large.value}"},
                    borderColor: {value: rule},
                },
            },
            divider: {
                borderColor: {value: rule},
                borderWidth: {value: "{borderWidths.small.value}"},
                opacity: {value: "1"},
            },
            // studioTheme hardcodes these two to fixed white/grey, which breaks dark mode
            menu: {
                backgroundColor: {value: surface},
                borderColor: {value: rule},
            },
            authenticator: {
                modal: {backgroundColor: {value: "rgba(14, 27, 51, 0.55)"}},  // ink overlay, not black
                router: {borderColor: {value: rule}},
                orContainer: {color: {value: inkMuted}},
            },
        },
    },
}, studioTheme);
